module.exports = __webpack_public_path__ + "img/r6.b5b92915.svg";